export default __webpack_public_path__ + "static/media/ecommerce.8a82e472.PNG";